import {Input} from './Input';

export class Number extends Input {
  FormatOptions: any;
  constructor(props) {
    super(props);
    this.FormatOptions = {};
  }
}
